
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kurslar",
      function () {
        return require("private-next-pages/kurslar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kurslar"])
      });
    }
  